import * as React from "react";
import { ITranslationProps, translateComponent } from "../../helpers/translation";
import IPasswordRequirement from "../../types/IPasswordRequirement";

import checkIcon from "../../iconic/check.svg";
import warningIcon from "../../iconic/warning.svg";

import "./ChangePasswordInput.css";

interface IPasswordRequirementStatusProps extends ITranslationProps {
    passwordRequirement: IPasswordRequirement
}

class PasswordRequirementStatus extends React.Component<IPasswordRequirementStatusProps> {
    constructor(props: IPasswordRequirementStatusProps) {
        super(props);
    }

    public render() {
        let colorClass: string = "";
        let icon: any = null;
        let altText = "";

        if (this.props.passwordRequirement.passwordMeetsRequirement) {
             colorClass = "text-success";
             icon = checkIcon;
             altText = this.props.t("PasswordRequirementStatus.RequirementsMetIcon");
        } else {
            colorClass = "text-danger";
            icon = warningIcon;
            altText = this.props.t("PasswordRequirementStatus.RequirementsNotMetIcon");
        }

        return (
            <div className={colorClass}> 
                <img src={icon} alt={altText} className="requirement-icon" />
                {this.props.passwordRequirement.description}
            </div>
        );
        
    }

}

export default translateComponent(PasswordRequirementStatus);



// WEBPACK FOOTER //
// ./src/core/ChangePasswordInput/PasswordRequirementStatus.tsx